import { can, type AuthorizedUser } from '@dma/auth';
import { AuthorizationError } from '@dma/shared';
import type { BannerRepository } from '../../domain/repositories/BannerRepository.interface';
import type { BannerDto } from '../dto/BannerDto';

export class GetBannerForAdminUseCase {
  constructor(private readonly repository: BannerRepository) {}

  public async execute(actingUser: AuthorizedUser | null): Promise<BannerDto | null> {
    if (!can(actingUser, 'settings:update')) {
      throw new AuthorizationError();
    }
    const banner = await this.repository.getForAdmin();
    return banner ? banner.props : null;
  }
}
